import { type ReactNode } from "react";

type TriggerSize = "md" | "lg";
type TriggerVariant = "gold" | "gold-soft";

export type CreateAccountCTAProps = {
  trigger?: ReactNode;
  label?: string;
  size?: TriggerSize;
  variant?: TriggerVariant;
  className?: string;
  withArrow?: boolean;
  source?: string;
  showGuestLink?: boolean;
};

/**
 * Pre-launch: the Create Account button is intentionally hidden site-wide.
 * The component is kept as a no-op so existing call sites continue to compile
 * without needing individual edits.
 */
export function CreateAccountCTA(_props: CreateAccountCTAProps) {
  return null;
}
